import React from 'react'

import { SvgProps } from './types'

function ExpandSvg({
  width,
  height,
  className,
  stroke,
  fill,
  strokeColor,
  size,
  styles,
}: SvgProps) {
  const { innerWidth } = window
  const defaultWidth = innerWidth > 1024 ? 's' : 'm'
  const sizeKey = typeof size === 'undefined' ? defaultWidth : size

  const scale = {
    xl: 3.0,
    lg: 2.5,
    m: 1.0,
    s: 0.8,
    xs: 0.5,
  }

  return (
    <svg
      className={className}
      style={{
        ...styles,
        ...{
          height: 'auto',
          transform: `scale(${scale[sizeKey]})`,
        },
      }}
      xmlns="http://www.w3.org/2000/svg"
      width={width || '48'}
      height={height || '48'}
      viewBox="0 0 24 24"
      fill={fill || 'none'}
    >
      <path
        d="M15 9L20 4M20 4V8M20 4H16"
        stroke={strokeColor || 'currentColor'}
        strokeWidth={stroke || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 15L4 20M4 20V16M4 20H8"
        stroke={strokeColor || 'currentColor'}
        strokeWidth={stroke || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ExpandSvg
